import { lazy } from "react";
import { PAYMENT_RESULT_ROUTE } from "./lib/payments/payu";
//Customer
const CustomerDashBoard = lazy(() => import('./Screen/Consumer/Dashboard/CustomerDashBoard'));
const CustomerRoofAnalysis = lazy(() => import('./Screen/Consumer/RoofAnalysis/ConsumerRoofAnalysis'));
const Login = lazy(() => import("./Screen/User/Login"));
const SignUp = lazy(() => import("./Screen/User/SignUp"));
const Components = lazy(() => import("./Screen/Compo"));
const Help = lazy(() => import("./Screen/Help/Help"))
const ProjectDashboard = lazy(() => import("./Screen/Consumer/Dashboard/ProjectDashboard"))
const OrderStatus = lazy(() => import("./Screen/Consumer/Dashboard/OrderStatus"))
const CustomerDashboardLanding = lazy(() => import("./Screen/Consumer/Dashboard/CustomerDashboardLanding"))
const Error404 = lazy(()=>import("./Components/ErrorPage/Error404"))
const PaymentResult = lazy(() => import("./Screen/Payment/PaymentResult"))

export type routeType = { path: string, Component: React.LazyExoticComponent<() => JSX.Element>, protected?: boolean }[];
export const routes: routeType = [
    { path: "/", Component: Login },
    { path: "/signup", Component: SignUp },
    { path: "/Comp", Component: Components },
    // PayU returns here (full-page redirect); the page checks the token itself
    { path: PAYMENT_RESULT_ROUTE, Component: PaymentResult },
    // { path: "/Consumer", Component: CustomerDashBoard,protected:true },
    { path: "/Consumer/RoofAnalysis", Component: CustomerRoofAnalysis, protected: true },
    { path: "/Consumer/Help", Component: Help, protected: true },
    { path: "/Consumer", Component: ProjectDashboard, protected: true },
    { path: "/Consumer/order_status", Component: OrderStatus, protected: true },
    // verify route need to comment, new route welcome added.
    { path: "/Consumer/verify", Component: CustomerDashboardLanding, protected: true },
    { path: "/Consumer/welcome", Component: CustomerDashboardLanding, protected: true },
    
]

